"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _GenericStore2 = _interopRequireDefault(require("./../../../../KESI2/Stores/GenericStore"));

var _MessagingService = _interopRequireDefault(require("../../MessagingService"));

var _ResumeSuspendListeners = require("../../../../helpers/ResumeSuspendListeners");

var _BuildConstants = require("../../../../utils/BuildConstants");

var _FeedbackService = require("../../FeedbackService");

var _GetFullLikes = _interopRequireDefault(require("../Services/GetFullLikes"));

var _FeedbackReceiveActions = _interopRequireDefault(require("./FeedbackReceiveActions2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var FEEDBACK_CHANNEL = "".concat(_BuildConstants.ABLY_CHANNEL_PREFIX, "SHORT_FEEDBACK");
var FEEDBACK_EVENT_NAME = 'answers';
var LIKE_EVENT_NAME = 'likes';
var FEED_BACK_SEND_STORE_PATHS = {
  FEEDBACK_QUEUE_NAME: 'feedbackMessageQueue'
};

var FeedbackSendStore = /*#__PURE__*/function (_GenericStore) {
  (0, _inherits2["default"])(FeedbackSendStore, _GenericStore);

  var _super = _createSuper(FeedbackSendStore);

  function FeedbackSendStore() {
    var _this;

    (0, _classCallCheck2["default"])(this, FeedbackSendStore);
    _this = _super.call(this);

    _this.init();

    return _this;
  }

  (0, _createClass2["default"])(FeedbackSendStore, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _MessagingService["default"].waitForInitialized();

              case 2:
                // set Presence ( implicit init and attach the channel )
                _MessagingService["default"].enterPresence(FEEDBACK_CHANNEL);

                _MessagingService["default"].registerConnect(FeedbackSendStore._renewPresence); // browser event on app stop


                window.addEventListener('unload', function () {
                  _MessagingService["default"].leavePresence(FEEDBACK_CHANNEL);
                }, false); // cordova event

                (0, _ResumeSuspendListeners.addOnSuspendListener)(function () {
                  _MessagingService["default"].leavePresence(FEEDBACK_CHANNEL);
                }); // cordova event

                (0, _ResumeSuspendListeners.addOnResumeListener)(function () {
                  _MessagingService["default"].enterPresence(FEEDBACK_CHANNEL);
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getList",
    value: function getList() {
      // get List from store
      var feedbackQueue = this.getValue(FEED_BACK_SEND_STORE_PATHS.FEEDBACK_QUEUE_NAME); // if empty create one

      return feedbackQueue && feedbackQueue.value ? feedbackQueue.value : [];
    }
    /**
     *
     * @param message
     *
     * store it in a persistent queue realized by an array
     * if the array length is equal one a dequeue action would be async called
     */

  }, {
    key: "feedbackMessageEnqueueAction",
    value: function feedbackMessageEnqueueAction(message) {
      var list = (0, _toConsumableArray2["default"])(this.getList()); // push message to List

      list.push(message); // store the List

      this.setValue(FEED_BACK_SEND_STORE_PATHS.FEEDBACK_QUEUE_NAME, {
        value: list
      }); // call asyncAction messageAvailable

      if (list.length === 1) {
        this.feedbackMessageDequeueAction({});
      }
    }
    /**
     * takes the first message from queue, try it to send
     * if success
     *    remove it from list
     *    if list not empty call next dequeue action after 5ms
     * else
     *    try dequeue action in 5 seconds again
     */

  }, {
    key: "feedbackMessageDequeueAction",
    value: function () {
      var _feedbackMessageDequeueAction = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this2 = this;

        var list, message, eventName, channel;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                list = (0, _toConsumableArray2["default"])(this.getList());

                if (!(list.length === 0)) {
                  _context3.next = 4;
                  break;
                }

                this.setValue(FEED_BACK_SEND_STORE_PATHS.FEEDBACK_QUEUE_NAME, {
                  value: list
                });
                return _context3.abrupt("return");

              case 4:
                // if list not empty get first message
                message = list.shift();
                eventName = FEEDBACK_EVENT_NAME;

                if (message && message.likeId) {
                  eventName = LIKE_EVENT_NAME;
                }

                _context3.next = 9;
                return _MessagingService["default"].getChannel(FEEDBACK_CHANNEL);

              case 9:
                channel = _context3.sent;
                _context3.prev = 10;
                _context3.next = 13;
                return _MessagingService["default"].sendMessage(channel, eventName, message);

              case 13:
                console.log('Successfull published', message, eventName, new Date().getTime());

                if (eventName === 'likes') {
                  console.log('init FeedbackService likeMessage');
                  setTimeout( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
                    var subscribed, likes;
                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            console.log('check if subscribed to like service');
                            _context2.next = 3;
                            return _MessagingService["default"].checkIfChannelSubscribed(FEEDBACK_CHANNEL);

                          case 3:
                            subscribed = _context2.sent;
                            console.log('check if subscribed to like service2', subscribed);

                            if (!subscribed) {
                              (0, _FeedbackService.init)()["catch"](function (error) {
                                console.error('Error initializing FeedbackService in sendstore', error);
                              });
                            }

                            _context2.next = 8;
                            return _GetFullLikes["default"].askForLikes();

                          case 8:
                            likes = _context2.sent;
                            console.log('readFullLikesAndFeedbacksAndListenAfterSuccess likes', likes);

                            if (likes) {
                              _FeedbackReceiveActions["default"].receiveChangesCompleted(likes);
                            }

                          case 11:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })), 1000);
                }

                this.setValue(FEED_BACK_SEND_STORE_PATHS.FEEDBACK_QUEUE_NAME, {
                  value: list
                });

                if (list.length > 0) {
                  // min 5ms deferred to prevent order issues at ably
                  setTimeout(function () {
                    _this2.feedbackMessageDequeueAction({});
                  }, 5);
                }

                _context3.next = 23;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](10);
                console.error('Error on send', _context3.t0, message); // repeat same action after 5 seconds

                setTimeout(function () {
                  _this2.feedbackMessageDequeueAction({});
                }, 5000);

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[10, 19]]);
      }));

      function feedbackMessageDequeueAction() {
        return _feedbackMessageDequeueAction.apply(this, arguments);
      }

      return feedbackMessageDequeueAction;
    }()
  }], [{
    key: "_renewPresence",
    value: function _renewPresence() {
      _MessagingService["default"].enterPresence(FEEDBACK_CHANNEL);
    }
  }]);
  return FeedbackSendStore;
}(_GenericStore2["default"]);

var feedBackSendStore = new FeedbackSendStore();
var _default = feedBackSendStore;
exports["default"] = _default;